export const HOST_INTEGRATIONS = {
  'googleAnalyticsSettings': true
}
